import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.SET_FEEDER_SERVICE_BL_LIST:
      return { ...action.feederServiceBLList };
    default:
      return state;
  }
};
